export default __webpack_public_path__ + "static/media/ET.c827a8fe.webp";